/**
 * @file Password API
 */

import axios from 'axios'

export default {
  async sendResetPasswordMail(tanaka_id) {
    return await axios.post(`users/send_reset_password_mail`, {
      tanaka_id,
    })
  },
  async resetPassword(token, password) {
    return await axios.post(`users/reset_password`, {
      reset_password_token: token,
      password: password,
    })
  },
}
